import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/app.scss';
import App from './App';
import * as serviceWorkerRegistration from './services/serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

serviceWorkerRegistration.register();
